export const PAYMENT_HANDLED_BY = {
  COMMERCE7: 'COMMERCE7',
  EXTERNAL: 'EXTERNAL'
};
